import { template as template_7f08c200882e4e69adab003f5bd50e6c } from "@ember/template-compiler";
import Captcha from 'client-portal/components/captcha';
import t from 'ember-intl/helpers/t';
export default template_7f08c200882e4e69adab003f5bd50e6c(`
  <div class="controls">
    <div class="row justify-content-between align-items-end">
      <div class="col-sm-5">
        {{#unless @isRecaptchaDisabled}}
          <Captcha @model={{@form}} />
        {{/unless}}
      </div>

      <div class="col-sm-4">
        <button
          class="button primary"
          type="submit"
          disabled={{@isSubmitting}}
          data-test-join-waitlist-submit
        >
          {{t "site.waitlistIntake.actions.joinWaitlist"}}
        </button>
      </div>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
